import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p className="footer-copyright">
            &copy; {currentYear} София World. С любовью для Софии Скрипуновой.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 